// extracted by mini-css-extract-plugin
export default {"comment":"ClaimsCommentsList-module__comment--_nvpF"};